<template>
  <div class="order-component">
    <div class="container container-order-list">
      <div class="order-content">
        <ul class="order-tabs">
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{'active-li': activeIndex === index}"
            @click="changeTab(index)"
          >{{tab}}</li>
        </ul>
        <div class="order-list">
          <order-list
            v-if="!activeIndex"
            v-loading="loading"
            :list="orderList"
            @getOrderList="getOrderList"
          >
            <el-pagination
              class="page-module"
              background
              layout="prev, pager, next, jumper, total"
              :total="page.total"
              prev-text="上一页"
              next-text="下一页"
              :page-size="page.pageNum"
              :current-page.sync="page.pageNo"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </order-list>
          <exchange-order-list
            v-if="activeIndex"
            :list="exchangeOrderList"
            v-loading="loading"
            @getExchangeOrderList="getExchangeOrderList"
          >
            <el-pagination
              class="page-module"
              background
              layout="prev, pager, next, jumper, total"
              :total="exchangePage.total"
              prev-text="上一页"
              next-text="下一页"
              :page-size="exchangePage.limit"
              :current-page.sync="exchangePage.start"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </exchange-order-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderList from './components/orderList'
import exchangeOrderList from './components/exchangeOrderList'

export default {
  components: {
    orderList, exchangeOrderList
  },
  data() {
    return {
      familyId: this.$cookies.get('familyId'),
      tabs: ['课程订单', '兑换订单'],
      activeIndex: 0,
      // 普通订单 分页对象
      page: {
        pageNo: 1,
        pageNum: 10,
        total: 0
      },
      // 兑换订单  分页对象
      exchangePage: {
        start: 1,
        limit: 10,
        total: 0
      },
      orderList: [],
      exchangeOrderList: [],
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getOrderList()
    },
    // tab切换  
    changeTab(index) {
      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
      index ? this.getExchangeOrderList() : this.getOrderList()
    },
    // 获取订单列表
    getOrderList() {
      this.loading = true
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/packorder/family/packorder/list',
        params: Object.assign({}, { source: 'PC', familyId: this.familyId, status: 1, _timeStamp: new Date().getTime() }, this.page)
      }).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.orderList = res.data.data.items
          this.page.total = res.data.data.total
          this.orderList.forEach(o => {
            o.versions === null && (o.versions = [])
          })
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    // 获取兑换订单
    getExchangeOrderList() {
      this.loading = true
      this.axios({
        method: 'get',
        url: '/parentrest/api/pc/exchangeOrder/findPageEshopOrder',
        params: Object.assign({}, { studentId: this.$cookies.get('studentId'), _timeStamp: new Date().getTime(), orderType: 'REAL,COURSE,PET_PROP,DOUBLE_EXCELLENT_COURSE' }, this.exchangePage)
      }).then(res => {
        if (res.data.code === 200) {
          this.exchangeOrderList = res.data.data.data
          this.exchangePage.total = res.data.data.totalCount
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    // 当前页数改变
    handleCurrentChange(val) {
      this.activeIndex ? this.getExchangeOrderList() : this.getOrderList()
    }
  }
}
</script>

<style lang="less" scoped>
.order-component {
  color: #333;
  background-color: #f9f9f9;
  padding: 25px 0;
  min-height: calc(100vh - 474px);
  .container-order-list {
    padding: 0 30px;
    .order-content {
      background-color: #fff;
    }
  }

  .order-header {
    padding: 19px 0 12px;
    font-size: 18px;
  }
  ul {
    &.order-tabs {
      border-top: 2px solid #ff8964;
      border-left: 1px solid #e7eaec;
      border-right: 1px solid #e7eaec;
      font-size: 16px;
      height: 42px;
      background-color: #fff0eb;
      li {
        display: inline-block;
        min-width: 110px;
        padding: 12px 0;
        cursor: pointer;
        height: 40px;
        line-height: 16px;
        text-align: center;
        &.active-li {
          background-color: #fff;
          position: relative;
          &::after {
            content: " ";
            position: absolute;
            display: block;
            width: 0;
            right: -6px;
            top: 0;
            border-right: 6px solid transparent;
            border-bottom: 40px solid #f6e0d9;
          }
        }
      }
    }
  }
  .order-list {
    border: 1px solid #e7eaec;
    border-top: none;
    padding: 30px 20px 0;
  }
  .page-module {
    margin: 15px 0;
    padding-left: 0;
    padding-right: 0;
  }
  /deep/.el-pagination {
    .btn-prev,
    .btn-next {
      padding: 0 10px;
    }
    .el-pagination__jump,
    .el-pagination__total {
      float: right;
    }
    &.is-background {
      .el-pager {
        li:not(.disabled):hover {
          color: #f60;
        }
        li:not(.disabled).active {
          background-color: #f60;
          color: #fff;
        }
      }
    }
  }
}
</style>
